import { useEffect, useState } from "react";
import React from "react";
import Head from "next/head";
import Sidebar from "../../Sidebar";
import Footer from "../../Footer";
import NavBar from "../../NavBar";
import { createUseStyles } from "react-jss";
import { usePathname, useRouter } from "next/navigation";
import { UIHeading, UIText } from "../UIElements";
import { Image } from "antd";
import { isUserLogin } from "@/common/empoyeerFunctions";
import { initEmployerAuthListener } from "@/common/checkEmployerAuth";
import { useDispatch } from "react-redux";

const EmployerLayout = ({ children, title }) => {
  const pathname = usePathname();
  const forgotPassword = pathname.includes("forgotpassword");
  const styles = useStyle();
  const router = useRouter();
  const dispatch = useDispatch();

  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    if (typeof window !== "undefined") return isUserLogin();
    return false;
  });

  useEffect(() => {
    const cleanup = initEmployerAuthListener({
      router,
      dispatch,
      forgotPassword,
      setIsLoggedIn,
    });

    return cleanup;
  }, [forgotPassword]);

  if (!isLoggedIn && forgotPassword) {
    return (
      <div className={styles.main}>
        <div className={styles.imgDiv}>
          <Image
            className={styles.img}
            src="https://cdn.hireside.com/cdn/images/Characters/SystemError1.svg"
            alt="Error Image"
            preview={false}
          />
        </div>

        <div className={styles.textDiv}>
          <UIHeading
            style={{
              fontWeight: 600,
              fontSize: 35,
              margin: 0,
              padding: 0,
            }}
          >
            You are not logged in
          </UIHeading>

          <UIText type="secondary" level={1} style={{ marginTop: 10 }}>
            Please log in to access your employer dashboard and manage your
            account.
          </UIText>

          <button
            onClick={() => router.replace("/employer?show_signup=true")}
            style={{ border: "none" }}
            className={styles.btn}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta name="author" content="HireSide" />
        <meta name="theme-color" content="#fff" />
        <meta name="custom1" content="hireside_www" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
        <meta
          name="description"
          content="Find a job that fits your skills, and get hired. HireSide is the best Job Platform."
        />
        <meta
          name="copyright"
          content="© 2022 - HireSide Inc. Developed by Verge Inc."
        />
        <title>{title || "Search Job | HireSide by WebHR"}</title>
      </Head>

      <NavBar />

      <div className={styles.appLayout}>
        <Sidebar />

        <main className={styles.contentWrap}>
          <div className={styles.contentCard}>
            {children}
            <div className={styles.footerDiv}>
              <Footer />
            </div>
            </div>
        </main>
      </div>

    </>
  );
};

const useStyle = createUseStyles({
  appLayout: {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
  },

  contentWrap: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },

  contentCard: {
    height: "100%",
    width: "99%",
    background: "#f8fafc",
    borderRadius: 22,
    boxShadow: "0 12px 35px rgba(15, 23, 42, 0.08)",
    border: "2px solid #eef2f7",
    overflowY: "auto",
    overflowX: "hidden",
    scrollBehavior: "smooth",

    "@media (max-width: 768px)": {
      padding: 14,
    },

    "@media (max-width: 425px)": {
      padding: 0,
    },
  },

  main: {
    background: "#FFFFFF",
    display: "flex",
    padding: "60px 20px",
    height: "100vh",

    "@media (max-width:800px)": {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  
  imgDiv: {
    width: "45vw",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    flexDirection: "column",

    "@media (max-width:800px)": {
      width: "100vw",
      alignItems: "center",
    },
  },

  textDiv: {
    width: "50vw",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "30px 0px",
    paddingLeft: 70,

    "@media (max-width:800px)": {
      width: "100vw",
      padding: "30px 30px",
      marginTop: 40,
    },
  },

  img: {
    width: 500,

    "@media (max-width:1000px)": {
      width: 380,
    },
  },

  btn: {
    width: 160,
    background: "#ff9c6e",
    padding: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontWeight: 550,
    marginTop: 30,
    borderRadius: 10,
    cursor: "pointer",

    "&:hover": {
      background: "#ffbb96",
    },
  },
});

export default EmployerLayout;